export function isMac() {
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
}
